export const FETCH = 'CAMPAIGNS_EDITOR/FETCH'
export const TOGGLE_LOADING = 'CAMPAIGNS_EDITOR/TOGGLE_LOADING'
export const UPDATE_ITEMS = 'CAMPAIGNS_EDITOR/UPDATE_ITEMS'
export const SET_DATA = 'CAMPAIGNS_EDITOR/SET_DATA'
export const RENAME = 'CAMPAIGNS_EDITOR/RENAME'
export const SET_FILTERS = 'CAMPAIGNS_EDITOR/SET_FILTERS'
export const SET_SELECTION = 'CAMPAIGNS_EDITOR/SET_SELECTION'
export const SET_SORTING = 'CAMPAIGNS_EDITOR/SET_SORTING'
export const MERGE_STATISTICS = 'CAMPAIGNS_EDITOR/MERGE_STATISTICS'
export const DROP_DATA = 'CAMPAIGNS_EDITOR/DROP_DATA'
export const SET_PAGE = 'CAMPAIGNS_EDITOR/SET_PAGE'
export const REFRESH_STATISTICS = 'CAMPAIGNS_EDITOR/REFRESH_STATISTICS'
export const UPDATE_ITEM_BY_ID = 'CAMPAIGNS_EDITOR/UPDATE_ITEM_BY_ID'
export const SET_RESOURCE = 'CAMPAIGNS_EDITOR/SET_RESOURCE'
export const DROP_ALL_ITEMS = 'CAMPAIGNS_EDITOR/DROP_ALL_ITEMS'
export const DROP_ALL_DATA = 'CAMPAIGNS_EDITOR/DROP_ALL_DATA'

export const FETCH_ADGROUPS_COUNTER = 'CAMPAIGNS_EDITOR/FETCH_ADGROUPS_COUNTER'
export const FETCH_BANNERS_COUNTER = 'CAMPAIGNS_EDITOR/FETCH_BANNERS_COUNTER'
export const SET_COUNTER = 'CAMPAIGNS_EDITOR/SET_COUNTER'

export const TOGGLE_GROUP_PROCESSING =
  'CAMPAIGNS_EDITOR/TOGGLE_GROUP_PROCESSING'
export const PROCESS_GROUP_ACTION_WITH_CONFIRMATION =
  'CAMPAIGNS_EDITOR/PROCESS_GROUP_ACTION_WITH_CONFIRMATION'
export const UPDATE_ITEMS_BY_ID = 'CAMPAIGNS_EDITOR/UPDATE_ITEMS_BY_ID'
